export function getEmployeeAction(contact) {
    if (!contact || !contact.isMapped) return "sync";
    const needsUpdate = contact.myGigsterEmployerEmployeeMapping?.needsUpdate === true;
    return needsUpdate ? "update" : "view";
}

export function canVerifyMvr(contact, employerRegistered) {
    return !!(contact && contact.isMapped && employerRegistered);
}